<div class="paddedContent">   
    <div class="headerHolder"><h4>Redirecting you to a Secure {{contactForm.label}} Form</h4></div>
    <p>Thank you for your patience. If you are not redirected, please click <a [href]="contactForm.url">here</a> to navigate directly to your form.</p>
    <p></p>
</div>
